import { NgModule } from '@angular/core';
import { HelpCardPage } from 'pages/help-card-page/help-card-page';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [HelpCardPage],
    imports: [PagesModule, ComponentsModule]
})
export class HelpCardPageModule {}
